import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTable from "../../components/ReactTable";
import editBond from "../../assets/editBond.png";
import axios from "axios";
import CustomPagination from "../../components/CustomPagination";
import { useDispatch } from "react-redux";
import { addCmsData } from "../../redux/cmsSlice";
import PartnerCMS from "./FIDCms";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const CmsList = () => {
  const navigate = useNavigate();
  const params=useParams()
  const dispacth = useDispatch();
  const [bondDetails, setBondDetails] = useState([]);
  const [cmsData, setCmsData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(0);

  const dummyData = [
    { name: "Home Page", id: 1, url: "/cms/homepage" },
    // { name: "Faq", id: 2, url: "/cms/faq" },
    { name: "Blog", id: 3, url: "/cms/blog" },
    { name: "About Us", id: 4, url: "/cms/aboutus" },
    { name: "Contact Us", id: 5, url: "/cms/contactus" },
    { name: "Announcement", id: 6, url: "/cms/announcement" },
  ];

  const getDate = () => {
    const now = new Date();
    return now.toISOString(); // Example of formatting the date  };
  };
  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("id", {
      cell: (info) => <div className="text-left">{info.row.index + 1}</div>,
      header: () => <div className="text-left font-semibold">S.No.</div>,
      meta: { width: "150px" },
    }),

    columnHelper.accessor("name", {
      cell: (info) => <div className="text-left">{info.renderValue()}</div>,
      header: () => <div className="text-left font-semibold">Name</div>,
      meta: { width: "200px" },
    }),

    // columnHelper.accessor("added", {
    //   cell: (info) => <div className="text-center">{getDate()}</div>,
    //   header: () => <div className="text-center font-semibold">Added Date</div>,
    //   meta: { width: "200px" },
    // }),

    // columnHelper.accessor("modify", {
    //   cell: (info) => <div className="text-center">{getDate()}</div>,
    //   header: () => (
    //     <div className="text-center font-semibold">Modify Date</div>
    //   ),
    //   meta: { width: "150px" },
    // }),

    columnHelper.accessor("actions", {
      cell: (info) => {
        const url = info?.row?.original?.url;
        return (
          <div className="flex justify-center">
            <img
              onClick={() => navigate(url)}
              src={editBond}
              alt="Edit"
              className="cursor-pointer"
            />
          </div>
        );
      },
      header: () => <div className="text-center font-semibold">Actions</div>,
    }),
  ];

  const handleNavigate=(url)=>{
    navigate(url)
  }

  return (
    <div className="container mx-auto md:px-5 py-3">
      {/* Header Section */}
      <div className="bg-white p-4 flex items-center justify-between rounded-lg mb-6 shadow-md mt-12">
        <h1 className="text-[#252C32] text-[24px] font-bold">
          Content Management
        </h1>
        <div className="flex justify-center gap-4">
        <button
        onClick={()=>handleNavigate("/cms/investor")}
          className={`px-4 py-2 rounded ${
            params?.type === "investor" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Investor
        </button>
        <button
        onClick={()=>handleNavigate("/cms/fid")}
          className={`px-4 py-2 rounded ${
            params?.type === "fid" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Fixed Income Distributor
        </button>
      </div>
      </div>


{/* Simple Tabs Placeholder */}







      {/* Table Section */}
      {params?.type ==="investor" &&(

        <div className="overflow-x-auto w-full mb-6">
        <ReactTable
          key={JSON?.stringify(dummyData)}
          defaultData={dummyData}
          columns={columns}
          className="table-auto w-full text-sm border-collapse"
          />
      </div>
        )}
        {/* Table Section */}
        {params?.type ==="fid" && (

          <div className="overflow-x-auto w-full mb-6">
            <PartnerCMS />
      </div>
        )}

      {/* Pagination Section */}
      {/* {bondDetails?.length > 0 && (
        <div className="w-full mt-4 flex justify-center">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={pageSize}
            maxPageNumbersToShow={5}
          />
        </div>
      )} */}
    </div>
  );
};

export default CmsList;
